import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue';
import DOMPurify from 'dompurify';


export default /*#__PURE__*/_defineComponent({
  props: {
  html: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



const sanitizedHtml = computed(() => DOMPurify.sanitize(props.html));

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", { sanitizedHtml: _unref(sanitizedHtml) }, () => [
    _createElementVNode("div", { innerHTML: _unref(sanitizedHtml) }, null, 8, _hoisted_1)
  ])
}
}

})